// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__f5H69","question":"Question_question__3Zmgk","description":"Question_description__iuEIV"};